import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

const EmailSettingsPage = lazy(() => import('./index'));

export default function SuspendedEmailSettingsPage() {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <EmailSettingsPage />
      </Suspense>
    </PageErrorBoundary>
  );
}
